export default __webpack_public_path__ + "1.17.19/static/media/LibreDataSharecode_SimplifiedChinese.f3c534ca.svg";